<template>
      <div class="timelines" id="timelines">
          <div class="timeline">
            <div class="timeline-header">
              <h2 class="text-title__about timeline-header">
                Educación
              </h2>
            </div>
            <div class="timeline-content">
              <div class="timeline-info" :key="item" v-for="item in education">
                <div class="info">
                  <div class="info-year">
                    <i class="fa fa-briefcase header-nav__i" aria-hidden="true"></i><p>{{item.year}}</p></div>
                  <h3>{{item.job}}</h3>
                  <p class="info-description">{{item.description}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="timeline">
               <div class="timeline-header">
              <h2 class="text-title__about timeline-header">
                Experiencias
              </h2>
            </div>
            <div class="timeline-content">
              <div class="timeline-info" :key="item" v-for="item in experiences">
               <div class="info">
                  <div class="info-year">
                    <i class="fa fa-briefcase header-nav__i" aria-hidden="true"></i><p>{{item.year}}</p></div>
                  <h3>{{item.job}}</h3>
                  <p class="info-description">{{item.description}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
</template>

<script>
export default {
    name: 'TimelineAbout',
    props:{
        education: Array,
        experiences: Array,

    }
}
</script>

<style>

</style>